import { memo } from 'react';

import styles from '../FileIconChat.styles.m.css';

export const FileIconRegular = memo(() => {
  return (
    <>
      <circle
        cx="24"
        cy="24"
        r="20"
        className={styles.primaryColor}
      />
      <path
        d="M31.5389 19.94C30.8766 18.7823 29.6443 17.6151 28.81 16.9C28.3341 16.4958 27.1146 15.4925 25.88 14.8429V19.63C25.88 19.8 26.02 19.94 26.19 19.94L31.5389 19.94Z"
        className={styles.secondaryColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.88 14.25H23.21C20.95 14.25 19.3 14.25 18.2 14.41C17.21 14.55 16.42 15.48 16.3 16.66C15.9 20.64 15.9 27.1 16.3 31.07C16.4 32.04 17.04 32.88 17.97 33.26C19.17 33.75 21.41 33.75 24 33.75C27.07 33.75 29.01 33.71 30.06 33.25C30.99 32.84 31.6 32.02 31.7 31.07C31.9477 28.6203 31.9934 24.2177 31.9993 21.94L26.19 21.94C24.91 21.94 23.88 20.9 23.88 19.63V14.25Z"
        className={styles.secondaryColor}
      />
    </>
  );
});
